"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var defaultConfig = {
  componentName: 'fuse-loading-spinner',
  colours: {
    primary: 'var(--color-brand-mid)',
    secondary: 'var(--color-global-black)',
    tertiary: 'var(--color-base-white)'
  }
};
var _default = exports["default"] = defaultConfig;